import { module as BaseModule } from "modujs"
import { DOMAnimations } from "../utils/dom"

export default class extends BaseModule {
  init() {
    const button = this.el.querySelector("[data-accordion-button]")
    if (!button) return

    const contentId = button.getAttribute("aria-controls")
    if (!contentId) return

    const content = document.getElementById(contentId)
    if (!content) return

    const isInitiallyExpanded = button.getAttribute("aria-expanded") === "true"

    // Ensure assistive technologies have a consistent state from first paint.
    button.setAttribute("aria-expanded", String(isInitiallyExpanded))
    content.setAttribute("aria-hidden", String(!isInitiallyExpanded))

    if (!button.id) {
      button.id = `accordion-trigger-${contentId}`
    }
    if (!content.getAttribute("role")) {
      content.setAttribute("role", "region")
    }
    if (!content.getAttribute("aria-labelledby")) {
      content.setAttribute("aria-labelledby", button.id)
    }

    if (isInitiallyExpanded) {
      content.style.display = "block"
    } else {
      content.style.display = "none"
    }

    button.addEventListener("click", () => {
      const isExpanded = button.getAttribute("aria-expanded") === "true"
      button.setAttribute("aria-expanded", String(!isExpanded))
      content.setAttribute("aria-hidden", String(isExpanded))

      if (isExpanded) {
        DOMAnimations.slideUp(content, 350)
        return
      }

      DOMAnimations.slideDown(content, 350)
    })
  }
}
